var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,22.5H9.3c-2.8,0-5.1-2.2-5.1-5v-1.9l-1.7-1.7c-0.5-0.5-0.8-1.1-0.8-1.8s0.3-1.3,0.8-1.8 C2.8,10,3.3,9.7,3.7,9.6c-0.6-1-0.4-2.3,0.4-3.1C4.9,5.7,6,5.5,7,5.9c0.1-0.5,0.3-1,0.7-1.3c0.9-0.9,2.4-1,3.5-0.2 c0.1-0.4,0.4-0.8,0.7-1.1c1-1,2.7-1,3.7,0l5.5,5.4c1.4,1.4,2.2,3.2,2.2,5.1s-0.8,3.7-2.2,5.1l-2,1.9C18,21.9,16.5,22.5,14.8,22.5z  M5.5,17v0.6c0,2,1.7,3.7,3.8,3.7h5.5c1.3,0,2.5-0.5,3.5-1.4l2-1.9c1.1-1.1,1.8-2.6,1.8-4.2s-0.6-3-1.8-4.2l-5.5-5.4 c-0.5-0.5-1.3-0.5-1.8,0c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.9l0.3,0.3c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.3-0.2,0.5 c-0.3,0.3-0.7,0.3-1,0l-1.7-1.6C10,5,9.2,5,8.7,5.5C8.4,5.8,8.3,6.1,8.3,6.4S8.4,7,8.7,7.3l1.7,1.6c0.1,0.1,0.2,0.3,0.2,0.5 s-0.1,0.3-0.2,0.5c-0.3,0.3-0.7,0.3-1,0L6.9,7.4c-0.5-0.5-1.3-0.5-1.8,0C4.8,7.7,4.7,8,4.7,8.3S4.8,9,5.1,9.2l2.5,2.4 c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.3-0.2,0.5c-0.3,0.3-0.7,0.3-1,0l-1.4-1.3c-0.5-0.5-1.3-0.5-1.8,0C3.1,11.5,3,11.8,3,12.1 s0.1,0.6,0.4,0.9l4.2,4c0.1,0.1,0.2,0.3,0.2,0.5S7.7,17.9,7.6,18c-0.3,0.3-0.7,0.3-1,0L5.5,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrab);
export default __webpack_public_path__ + "static/media/grab.c981fb69bba722c1f67af6c16a3666db.svg";
export { ForwardRef as ReactComponent };